import React, { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { CheckSuccessIcon, Closewhiteicon } from './svgIcon';
import { setSuccessNotification } from '../../redux/slices/NotificationSlice';

function NotificationUI({ message }) {
  const dispatch = useDispatch();
  return (
    <div className="flew-row">
      <CheckSuccessIcon />
      <div className="message">{message}</div>
      <span
        role="presentation"
        onClick={() => dispatch(setSuccessNotification({ status: false, message: '' }))}
      >
        <Closewhiteicon />
      </span>
    </div>
  );
}

function NotificationMessage() {
  const dispatch = useDispatch();
  const { successNotification } = useSelector((state) => state.notification);
  const animationKeyframes = `
    @keyframes topInFromRight {
      0% {
        bottom: -50px;
        opacity: 0;
        width: 64px;
        height: 64px;
        border-radius: 8px;
        content-visibility: hidden;
        background: #323232;
      }
      40% {
        bottom: 25px;
        opacity: 1;
        width: 64px;
        height: 64px;
        content-visibility: hidden;
        border-radius: 8px;
        background: #323232;
        overflow: hidden;
      }
      87% {
        width: 302px;
        height: 64px;
        background: #323232;
        border-radius: 8px;
        overflow: hidden;
        content-visibility: hidden;
      }
      100% {
        width: 302px;
        height: 64px;
        background: #323232;
        border-radius: 8px;
        overflow: visible;
        content-visibility: visible;
      }
    }
  `;

  useEffect(() => {
    if (successNotification.status) {
      const timer = setTimeout(() => {
        dispatch(setSuccessNotification({ status: false, message: '' }));
      }, 6000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [successNotification]);
  return (
    <>
      {/* Inject keyframes for the animation */}
      <style>
        {animationKeyframes}
      </style>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={successNotification?.status}
        sx={{
          whiteSpace: 'nowrap',
          animation: 'topInFromRight 1s ease-in-out',
        }}
        message={(
          <NotificationUI
            message={successNotification?.message}
          />
        )}
      />
    </>
  );
}

NotificationUI.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NotificationMessage;
